import { useLenis } from "../hooks/useLenis";
import { LanguageProvider } from "../i18n/LanguageContext";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { EditorialMarquee } from "../components/site/EditorialMarquee";
import { Portfolio } from "../components/site/Portfolio";
import { Services } from "../components/site/Services";
import { FieldWork } from "../components/site/FieldWork";
import { HowWeWork } from "../components/site/HowWeWork";
import { Pricing } from "../components/site/Pricing";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";

export default function Home() {
  useLenis();
  return (
    <LanguageProvider>
      <div className="grain grid-lines relative bg-cream min-h-screen">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Portfolio />
          <Services />
          <FieldWork />
          <HowWeWork />
          <Pricing />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}
